<div class="flex-1 flex flex-col">

    <div class="text-xs font-semibold text-gray-800 p-3 cursor-pointer" (click)="goBack()">
        Back
    </div>

    <div class="content-form p-4">
        <div class="bg-gray-100 -mx-4 -mt-4 mb-4">
            <div class="flex items-center p-3 max-w-[1920px] mx-auto">
                <h3 class="text-xs font-semibold text-gray-800">
                    Product Details
                </h3>
            </div>
        </div>
        <div class="max-w-[1920px] mx-auto px-3 grid grid-cols-1 lg:grid-cols-2">
            <div class="items-center lg:pr-6">
                <div class="mb-6">
                    <h3 class="text-xs font-bold text-gray-900 pb-2 border-b border-gray-200 w-fit">
                        Genaral Details
                    </h3>
                </div>
                <div class="grid grid-cols-1 gap-4 mb-4">
                    <div class="relative" *ngIf="isEdit">
                        <input type="text" id="productCode" class="input-M peer w-64" placeholder=" "
                               name="productCode"
                               [(ngModel)]="productCode" readonly>
                        <label class="label" for="productCode">Product Code<span class="text-red-700">*</span></label>
                    </div>
                    <div class="relative">
                        <input type="text" id="customerProductCode"
                               class="input-M peer w-64"
                               placeholder=" "
                               name="customerProductCode"
                               [(ngModel)]="customerProductCode">
                        <label class="label" for="customerProductCode">Customer Product Code</label>
                    </div>
                </div>
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                    <div class="relative">
                        <select
                                id="department"
                                name="department"
                                class="input-M peer w-64"
                                [class.!border-red-500]="validationErrors.department"
                                [(ngModel)]="selectedDepartment"
                                (change)="onDepartmentChange(); validationErrors.department = false"
                                [disabled]="isEdit"
                        >
                            <option value="" disabled selected hidden></option>
                            <option value="Flexo">Flexo</option>
                            <option value="Offset">Offset</option>
                            <option value="Digital">Digital</option>
                        </select>
                        <label class="label" for="department">
                            Department<span class="text-red-700">*</span>
                        </label>
                        <p *ngIf="validationErrors.department" class="validation-error">Department is required.</p>
                    </div>
                    <div class="relative">
                        <select
                                id="category"
                                name="category"
                                class="input-M peer w-64"
                                [(ngModel)]="category"
                                [disabled]="!isCategoryEnabled || isEdit"
                                (change)="onCategoryChange()"
                        >
                            <option value="" disabled selected hidden></option>
                            <option value="Cartoon">Cartoon</option>
                            <option value="Gift Box">Gift Box</option>
                            <option value="Book">Book</option>
                            <option value="Label">Label</option>
                        </select>
                        <label class="label" for="category">
                            Category
                        </label>
                    </div>
                </div>
                <div class="mb-6">
                    <div class="grid grid-cols-1 gap-4 mb-4">
                        <div class="relative">
                                <textarea id="productName"
                                          class="input-M peer w-64"
                                          [class.!border-red-500]="validationErrors.productName"
                                          placeholder=" " rows="3"
                                          name="productName"
                                          [(ngModel)]="productName"
                                          (ngModelChange)="validationErrors.productName = false"></textarea>
                            <label class="label" for="productName">Product Name<span class="text-red-700">*</span></label>
                            <p *ngIf="validationErrors.productName" class="validation-error">Product Name is required.</p>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 gap-4 mb-4">
                        <div class="relative">
                            <input
                                type="text"
                                id="customer"
                                class="input-M peer w-64"
                                [class.!border-red-500]="validationErrors.customer"
                                placeholder=" "
                                name="customer"
                                autocomplete="off"
                                [(ngModel)]="customer"
                                (ngModelChange)="onCustomerChange($event); validationErrors.customer = false"
                                (focus)="onCustomerFocus()"
                                (click)="onCustomerFocus()"
                                (blur)="hideCustomerDropdown()"
                            />
                            <label class="label" for="customer">Customer<span class="text-red-700">*</span></label>
                            <p *ngIf="validationErrors.customer" class="validation-error">Customer is required.</p>

                            <div
                                *ngIf="customerDropdownOpen() && filteredCustomers().length > 0"
                                class="absolute z-50 w-full bg-white border border-gray-200 rounded shadow-lg max-h-48 overflow-y-auto"
                            >
                                <div
                                    *ngFor="let c of filteredCustomers()"
                                    class="px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer"
                                    (mousedown)="selectCustomer(c); $event.preventDefault()"
                                >
                                    {{ c.customerName }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mb-6"></div>
                </div>

                <div class="mb-2">
                    <h3 class="text-xs font-bold text-gray-900 w-fit">
                        References
                    </h3>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                    <div class="relative">
                        <input type="text" id="salesOrder" class="input-M peer w-64"
                               [class.!border-red-500]="validationErrors.salesOrder"
                               placeholder=" "
                               name="salesOrder"
                               [(ngModel)]="salesOrder"
                               (ngModelChange)="validationErrors.salesOrder = false">
                        <label class="label" for="salesOrder">Sales Order<span class="text-red-700">*</span></label>
                        <p *ngIf="validationErrors.salesOrder" class="validation-error">Sales Order is required.</p>
                    </div>
                    <div class="relative">
                        <input type="text" id="quotationNo" class="input-M peer w-64"
                               [class.!border-red-500]="validationErrors.quotationNo"
                               placeholder=" "
                               name="quotationNo"
                               [(ngModel)]="quotationNo"
                               (ngModelChange)="validationErrors.quotationNo = false">
                        <label class="label" for="quotationNo">Quotation No<span class="text-red-700">*</span></label>
                        <p *ngIf="validationErrors.quotationNo" class="validation-error">Quotation No is required.</p>
                    </div>
                </div>
                <div class="mb-2">
                    <h3 class="text-xs font-bold text-gray-900 w-fit">
                        Artwork Details
                    </h3>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                    <div class="relative">
                        <input type="text" id="artworkNo" class="input-M peer w-64" placeholder=" "
                               name="artworkNo"
                               [(ngModel)]="artworkNo">
                        <label class="label" for="artworkNo">Artwork No</label>
                    </div>
                    <div class="relative">
                        <input type="number" id="version" class="input-M peer w-64" placeholder=" "
                               name="version"
                               [(ngModel)]="version">
                        <label class="label" for="version">Version / Revision</label>
                    </div>
                </div>
            </div>


            <!-- right Side -->
            <div class="items-center lg:border-l lg:border-gray-300 lg:pl-6">
                <div class="mb-6">
                    <h3 class="text-xs font-bold text-gray-900 pb-2 border-b border-gray-200 w-fit">
                        Packaging specifications
                    </h3>
                </div>
                <div class="mb-6" *ngIf="selectedDepartment === 'Offset'">
<!--                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">-->
<!--                        <div class="relative">-->
<!--                            <input type="text" id="fullSheetSize" class="input-M peer w-64" placeholder=" "-->
<!--                                   name="fullSheetSize"-->
<!--                                   [(ngModel)]="fullSheetSize">-->
<!--                            <label class="label" for="fullSheetSize">Full Sheet Size</label>-->
<!--                        </div>-->
<!--                        <div class="relative">-->
<!--                            <input type="text" id="cutSheetSize" class="input-M peer w-64" placeholder=" "-->
<!--                                   name="cutSheetSize"-->
<!--                                   [(ngModel)]="cutSheetSize">-->
<!--                            <label class="label" for="cutSheetSize">Cut Sheet Size</label>-->
<!--                        </div>-->

<!--                    </div>-->
                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4" *ngIf="category === 'Cartoon'">

                        <div class="relative">
                            <input type="text" id="productSize" class="input-M peer w-64" placeholder=" "
                                   name="productSize"
                                   [(ngModel)]="productSize">
                            <label class="label" for="productSize">Product Size</label>
                        </div>
                        <div class="relative">
                            <select
                                    id="pastingType"
                                    name="pastingType"
                                    class="input-M peer w-64"
                                    [(ngModel)]="selectedPastingType"
                                    (change)="onPastingTypeChange()"
                            >
                                <option value="" selected hidden></option>
                                <option value="Side Pasting">Side Pasting</option>
                                <option value="Both Side">Both side </option>
                                <option value="Top and Bottom Pasting">Top and Bottom Pasting</option>
                            </select>
                            <label class="label" for="pastingType">
                                Pasting Type
                            </label>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4" *ngIf="category === 'Gift Box'">
                        <div class="relative">
                            <select
                                    id="giftBoxBoardType"
                                    name="giftBoxBoardType"
                                    class="input-M peer w-64"
                                    [(ngModel)]="selectedGiftBoxBoardType"
                                    (change)="onPastingTypeChange()"
                            >
                                <option value="" selected hidden></option>
                                <option value="Chip Board">Chip Board</option>
                                <option value="Art Board">Art Board</option>
                            </select>
                            <label class="label" for="giftBoxBoardType">
                                Gift Box Board Type
                            </label>
                        </div>
                        <div class="relative">
                            <input type="text" id="thickness" class="input-M peer w-64" placeholder=" "
                                   name="thickness"
                                   [(ngModel)]="thickness">
                            <label class="label" for="thickness">Thickness / GSM</label>
                        </div>
                        <div class="relative">
                            <select
                                    id="giftBoxType"
                                    name="giftBoxType"
                                    class="input-M peer w-64"
                                    [(ngModel)]="selectedGiftBoxType"
                                    (change)="onGiftBoxTypeChange()"
                            >
                                <option value="" selected hidden></option>
                                <option value="Lid and Base">Lid and Base</option>
                                <option value="Side Open">Side Open</option>
                                <option value="Top Open">Top Open</option>
                                <option value="Other">Other</option>
                            </select>
                            <label class="label" for="giftBoxType">
                                Gift Box Type
                            </label>
                        </div>
                    </div>
                    <div *ngIf="category === 'Book'">
                        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                            <div class="relative">
                                <select
                                        id="bookCoverType"
                                        name="bookCoverType"
                                        class="input-M peer w-64"
                                        [(ngModel)]="selectedBookCoverType"
                                        (change)="onBookCoverTypeChange()"
                                >
                                    <option value="" selected hidden></option>
                                    <option value="Hard Cover">Hard Cover</option>
                                    <option value="Soft Cover">Soft Cover</option>
                                    <option value="Leather Cover">Leather Cover</option>
                                </select>
                                <label class="label" for="bookCoverType">
                                    Book Cover Type
                                </label>
                            </div>
                            <div class="relative">
                                <input type="text" id="coverThickness" class="input-M peer w-64" placeholder=" "
                                       name="coverThickness"
                                       [(ngModel)]="coverThickness">
                                <label class="label" for="coverThickness">Cover Thickness / GSM</label>
                            </div>
                            <div class="relative">
                                <input type="text" id="coverWidth" class="input-M peer w-64" placeholder=" "
                                       name="coverWidth"
                                       [(ngModel)]="coverWidth">
                                <label class="label" for="coverWidth">Cover Width</label>
                            </div>
                            <div class="relative">
                                <input type="text" id="coverLength" class="input-M peer w-64" placeholder=" "
                                       name="coverLength"
                                       [(ngModel)]="coverLength">
                                <label class="label" for="coverLength">Cover Length</label>
                            </div>
                        </div>
                        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                            <div class="relative">
                                <input type="text" id="innerpageWidth" class="input-M peer w-64" placeholder=" "
                                       name="innerpageWidth"
                                       [(ngModel)]="innerpageWidth">
                                <label class="label" for="innerpageWidth">Inner Page Width</label>
                            </div>
                            <div class="relative">
                                <input type="text" id="coverLength" class="input-M peer w-64" placeholder=" "
                                       name="coverLength"
                                       [(ngModel)]="innerpageLength">
                                <label class="label" for="innerpageLength">Inner Page Length</label>
                            </div>
                            <div class="relative">
                                <select
                                        id="pageBindingType"
                                        name="pageBindingType"
                                        class="input-M peer w-64"
                                        [(ngModel)]="selectedPageBindingType"
                                        (change)="onPageBindingTypeChange()"
                                >
                                    <option value="" selected hidden></option>
                                    <option value="Perfect Binding">Perfect Binding</option>
                                    <option value="Center Wire">Center Wire</option>
                                    <option value="Spiral">Spiral</option>
                                </select>
                                <label class="label" for="pageBindingType">
                                    Inner Pages Binding Type
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="mb-2">
                        <h3 class="text-xs font-bold text-gray-900 w-fit">Product Specification</h3>
                    </div>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                        <div class="relative">
                            <input type="text" id="offsetWidthMm" class="input-M peer w-64" placeholder=" "
                                   name="offsetWidthMm"
                                   [(ngModel)]="widthMm">
                            <label class="label" for="offsetWidthMm">Width</label>
                        </div>
                        <div class="relative">
                            <input type="text" id="offsetLengthMm" class="input-M peer w-64" placeholder=" "
                                   name="offsetLengthMm"
                                   [(ngModel)]="lengthMm">
                            <label class="label" for="offsetLengthMm">Length</label>
                        </div>
                    </div>

                </div>
                <div class="mb-6" *ngIf="selectedDepartment === 'Flexo'">
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                        <div class="relative">
                            <select
                                    id="flexoType"
                                    name="flexoType"
                                    class="input-M peer w-64"
                                    [class.!border-red-500]="validationErrors.flexoType"
                                    [(ngModel)]="flexoType"
                                    (change)="onFlexoTypeChange(); validationErrors.flexoType = false"
                            >
                                <option value="" disabled selected hidden></option>
                                <option value="Reel">Reel</option>
                                <option value="Sheet">Sheet</option>
                            </select>
                            <label class="label" for="flexoType">Type<span class="text-red-700">*</span></label>
                            <p *ngIf="validationErrors.flexoType" class="validation-error">Type is required.</p>
                        </div>
                    </div>

                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4" *ngIf="flexoType === 'Reel'">
                        <div class="relative">
                            <input type="text" id="coreSize" class="input-M peer w-64" placeholder=" "
                                   name="coreSize"
                                   [(ngModel)]="coreSize">
                            <label class="label" for="coreSize">Core Size</label>
                        </div>
                        <div class="relative">
                            <input type="number" id="noOfUps" class="input-M peer w-64" placeholder=" "
                                   name="noOfUps"
                                   [(ngModel)]="noOfUps">
                            <label class="label" for="noOfUps">No of UPS</label>
                        </div>
                        <div class="relative">
                            <input type="number" id="pcsPerRoll" class="input-M peer w-64" placeholder=" "
                                   name="pcsPerRoll"
                                   [(ngModel)]="pcsPerRoll">
                            <label class="label" for="pcsPerRoll">Pcs per Roll</label>
                        </div>
                        <div class="relative">
                            <select id="windingDirection" class="input-M peer w-64"
                                    name="windingDirection"
                                    [(ngModel)]="windingDirection">
                                <option value="" disabled selected hidden></option>
                                <option *ngFor="let dir of windingDirections" [value]="dir">{{ dir }}</option>
                            </select>
                            <label class="label" for="windingDirection">Winding Direction</label>
                        </div>
                    </div>

                    <div class="grid grid-cols-1 gap-4 mb-4" *ngIf="flexoType">
                        <div class="relative">
                            <textarea id="flexoRemark" class="input-M peer w-64" placeholder=" " rows="2"
                                      name="flexoRemark"
                                      [(ngModel)]="flexoRemark"></textarea>
                            <label class="label" for="flexoRemark">Remark</label>
                        </div>
                    </div>

                    <div class="mb-2">
                        <h3 class="text-xs font-bold text-gray-900 w-fit">Product Specification</h3>
                    </div>
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                        <div class="relative">
                            <input type="text" id="widthMm" class="input-M peer w-64" placeholder=" "
                                   name="widthMm"
                                   [(ngModel)]="widthMm">
                            <label class="label" for="widthMm">Width</label>
                        </div>
                        <div class="relative">
                            <input type="text" id="lengthMm" class="input-M peer w-64" placeholder=" "
                                   name="lengthMm"
                                   [(ngModel)]="lengthMm">
                            <label class="label" for="lengthMm">Length</label>
                        </div>
                    </div>
                </div>
                <!-- Digital: show only the Print section -->
                <div class="mb-6" *ngIf="selectedDepartment === 'Digital'">
                    <div class="mb-2">
                        <h3 class="text-xs font-bold text-gray-900 w-fit">Print</h3>
                    </div>
                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                        <div class="relative">
                            <input type="number" id="noOfColors_d" class="input-M peer w-64" placeholder=" "
                                   name="noOfColors" [(ngModel)]="noOfColors">
                            <label class="label" for="noOfColors_d">No of colors</label>
                        </div>
<!--                        <div class="relative">-->
<!--                            <input type="number" id="noOfUps_d" class="input-M peer w-64" placeholder=" "-->
<!--                                   name="noOfUps" [(ngModel)]="noOfUps">-->
<!--                            <label class="label" for="noOfUps_d">No of UPS</label>-->
<!--                        </div>-->
<!--                        <div class="relative">-->
<!--                            <input type="text" id="proofStandard_d" class="input-M peer w-64" placeholder=" "-->
<!--                                   name="proofStandard" [(ngModel)]="proofStandard">-->
<!--                            <label class="label" for="proofStandard_d">Proof Standard</label>-->
<!--                        </div>-->
                        <div class="relative">
                            <input
                                    type="text"
                                    id="printingMachine_d"
                                    class="input-M peer w-64"
                                    placeholder=" "
                                    name="printingMachine"
                                    [(ngModel)]="printingMachine"
                                    (input)="printingMachineDropdownOpen = true"
                                    (focus)="printingMachineDropdownOpen = true"
                                    (blur)="onPrintingMachineBlur()"
                                    autocomplete="off"
                            />
                            <label class="label" for="printingMachine_d">Printing Machine</label>
                            <div *ngIf="printingMachineDropdownOpen"
                                 class="absolute z-50 w-full bg-white border border-gray-200 rounded shadow-lg max-h-48 overflow-y-auto">
                                <div *ngFor="let m of filteredPrintingMachines()"
                                     class="px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer"
                                     (mousedown)="selectPrintingMachine(m.machineName)">
                                    {{ m.machineName }}
                                    <span class="text-gray-400 ml-1">({{ m.capabilities }})</span>
                                </div>
                                <div *ngIf="filteredPrintingMachines().length === 0"
                                     class="px-3 py-2 text-xs text-gray-400">No results</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Offset / Flexo: shared Print sub-section -->
                <div class="mb-6" *ngIf="selectedDepartment === 'Offset' || selectedDepartment === 'Flexo'">
                    <div class="mb-2">
                        <h3 class="text-xs font-bold text-gray-900 w-fit">Print</h3>
                    </div>
                    <div class="mb-6">
                        <div class="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                            <div class="relative">
                                <input type="number" id="noOfColors" class="input-M peer w-64" placeholder=" "
                                       name="noOfColors"
                                       [(ngModel)]="noOfColors">
                                <label class="label" for="noOfColors">No of colors</label>
                            </div>
<!--                            <div class="relative">-->
<!--                                <input type="number" id="noOfUps" class="input-M peer w-64" placeholder=" "-->
<!--                                       name="noOfUps"-->
<!--                                       [(ngModel)]="noOfUps">-->
<!--                                <label class="label" for="noOfUps">No of UPS</label>-->
<!--                            </div>-->
<!--                            <div class="relative">-->
<!--                                <input type="text" id="proofStandard" class="input-M peer w-64" placeholder=" "-->
<!--                                       name="proofStandard"-->
<!--                                       [(ngModel)]="proofStandard">-->
<!--                                <label class="label" for="proofStandard">Proof Standard</label>-->
<!--                            </div>-->

<!--                            &lt;!&ndash; Printing Machine Dropdown &ndash;&gt;-->
<!--                            <div class="relative">-->
<!--                                <input-->
<!--                                        type="text"-->
<!--                                        id="printingMachine"-->
<!--                                        class="input-M peer w-64"-->
<!--                                        placeholder=" "-->
<!--                                        name="printingMachine"-->
<!--                                        [(ngModel)]="printingMachine"-->
<!--                                        (input)="printingMachineDropdownOpen = true"-->
<!--                                        (focus)="printingMachineDropdownOpen = true"-->
<!--                                        (blur)="onPrintingMachineBlur()"-->
<!--                                />-->
<!--                                <label class="label" for="printingMachine">Printing Machine</label>-->

<!--                                <div-->
<!--                                        *ngIf="printingMachineDropdownOpen"-->
<!--                                        class="absolute z-50 w-full bg-white border border-gray-200 rounded shadow-lg max-h-48 overflow-y-auto"-->
<!--                                >-->
<!--                                    <div-->
<!--                                            *ngFor="let m of filteredPrintingMachines()"-->
<!--                                            class="px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer"-->
<!--                                            (mousedown)="selectPrintingMachine(m.machineName)"-->
<!--                                    >-->
<!--                                        {{ m.machineName }}-->
<!--                                        <span class="text-gray-400 ml-1">({{ m.capabilities }})</span>-->
<!--                                    </div>-->
<!--                                    <div-->
<!--                                            *ngIf="filteredPrintingMachines().length === 0"-->
<!--                                            class="px-3 py-2 text-xs text-gray-400"-->
<!--                                    >-->
<!--                                        No results-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->

                        </div>
                    </div>
                </div>

<!--                <div class="mb-2">-->
<!--                    <h3 class="text-xs font-bold text-gray-900 w-fit">-->
<!--                        Finishings-->
<!--                    </h3>-->
<!--                </div>-->

<!--                <div-->
<!--                        class="flex gap-4 mb-2 items-center"-->
<!--                        *ngFor="let finishing of finishings(); let i = index"-->
<!--                >-->
<!--                    &lt;!&ndash; Process Dropdown &ndash;&gt;-->
<!--                    <div class="relative flex-1">-->
<!--                        <input-->
<!--                                type="text"-->
<!--                                class="input-M peer w-full"-->
<!--                                placeholder=" "-->
<!--                                [name]="'process' + i"-->
<!--                                [(ngModel)]="finishingSearch[i]"-->
<!--                                (input)="finishingDropdownOpen = i"-->
<!--                                (focus)="finishingDropdownOpen = i"-->
<!--                                (blur)="onFinishingBlur(i)"-->
<!--                        />-->
<!--                        <label class="label">Process</label>-->

<!--                        <div-->
<!--                                *ngIf="finishingDropdownOpen === i"-->
<!--                                class="absolute z-50 w-full bg-white border border-gray-200 rounded shadow-lg max-h-48 overflow-y-auto"-->
<!--                        >-->
<!--                            <div-->
<!--                                    *ngFor="let f of filteredFinishings(i)"-->
<!--                                    class="px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer"-->
<!--                                    (mousedown)="selectFinishing(i, f.Finishing)"-->
<!--                            >-->
<!--                                {{ f.Finishing }}-->
<!--                            </div>-->
<!--                            <div-->
<!--                                    *ngIf="filteredFinishings(i).length === 0"-->
<!--                                    class="px-3 py-2 text-xs text-gray-400"-->
<!--                            >-->
<!--                                No results-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    &lt;!&ndash; Machine Dropdown &ndash;&gt;-->
<!--                    <div class="relative flex-1">-->
<!--                        <input-->
<!--                                type="text"-->
<!--                                class="input-M peer w-full"-->
<!--                                placeholder=" "-->
<!--                                [name]="'machine' + i"-->
<!--                                [(ngModel)]="machineSearch[i]"-->
<!--                                (input)="machineDropdownOpen = i"-->
<!--                                (focus)="machineDropdownOpen = i"-->
<!--                                (blur)="onMachineBlur(i)"-->
<!--                        />-->
<!--                        <label class="label">Machine</label>-->

<!--                        <div-->
<!--                                *ngIf="machineDropdownOpen === i"-->
<!--                                class="absolute z-50 w-full bg-white border border-gray-200 rounded shadow-lg max-h-48 overflow-y-auto"-->
<!--                        >-->
<!--                            <div-->
<!--                                    *ngFor="let m of filteredMachines(i)"-->
<!--                                    class="px-3 py-2 text-xs hover:bg-blue-50 cursor-pointer"-->
<!--                                    (mousedown)="selectMachine(i, m.machineName)"-->
<!--                            >-->
<!--                                {{ m.machineName }}-->
<!--                                <span class="text-gray-400 ml-1">({{ m.capabilities }})</span>-->
<!--                            </div>-->
<!--                            <div-->
<!--                                    *ngIf="filteredMachines(i).length === 0"-->
<!--                                    class="px-3 py-2 text-xs text-gray-400"-->
<!--                            >-->
<!--                                No results-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    &lt;!&ndash; Remarks &ndash;&gt;-->
<!--                    <div class="relative flex-1">-->
<!--                        <input-->
<!--                                type="text"-->
<!--                                class="input-M peer w-full"-->
<!--                                placeholder=" "-->
<!--                                [name]="'remarks' + i"-->
<!--                                [(ngModel)]="finishing.remarks"-->
<!--                        />-->
<!--                        <label class="label">Remarks</label>-->
<!--                    </div>-->

<!--                    &lt;!&ndash; Delete &ndash;&gt;-->
<!--                    <button-->
<!--                            type="button"-->
<!--                            class="h-10 w-10 flex items-center justify-center rounded text-red-600 hover:bg-red-100"-->
<!--                            (click)="removeFinishing(i)"-->
<!--                            *ngIf="finishings().length > 1"-->
<!--                            title="Delete finishing"-->
<!--                    >-->
<!--                        🗑️-->
<!--                    </button>-->
<!--                </div>-->

                <div class="flex justify-between items-center mt-4">
<!--                    <button-->
<!--                            type="button"-->
<!--                            class="button-blue"-->
<!--                            (click)="addFinishing()"-->
<!--                    >-->
<!--                        Add Finishing-->
<!--                    </button>-->

                    <button
                            type="button"
                            class="button-blue"
                            (click)="saveProduct()"
                    >
                        {{ isEdit ? 'Update' : 'Save Product' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>